interface Iprops {
  width: number;
  height: number;
  active: boolean;
}

export const DashboardIcon = ({ width, height, active }: Iprops) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {active && (
        <rect
          width="28"
          height="28"
          rx="4"
          transform="matrix(-1 0 0 1 28 0)"
          fill="#DDEDF4"
        />
      )}
      <path
        d="M17 20H19V11.5H17V20ZM13 20H15V8.5H13V20ZM9 20H11V14.5H9V20ZM6.5 21.6H21.5V6.5H6.5V21.6ZM6.5 5H21.5C22.6 5 23 5.4 23 6.5V21.5C23 22.6 22.6 23 21.5 23H6.5C5.4 23 5 22.6 5 21.5V6.5C5 5.4 5.4 5 6.5 5Z"
        fill={active ? "#811797" : "#7B7B7B"}
      />
    </svg>
  );
};
